import React, { useLayoutEffect, useMemo } from 'react';
import { Wrapper, SizeContainer, LinksContainer, LinksItem, LinksList, StyledLink } from './footer.styles';
import { useFilesListNoAuthSharedQuery } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/use-files-list-no-auth-shared-query';
import { DEFAULT_PARAMETERS } from './constants';
import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';
import { getFileUrlByCode } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/get-file-url-by-code';

export const Footer: React.FC = () => {
    const [getFilesNoAuthList, getFilesNoAuthListResult] = useFilesListNoAuthSharedQuery(DEFAULT_PARAMETERS);
    const filesData = getFilesNoAuthListResult.data?.items || [];

    useLayoutEffect(() => {
        getFilesNoAuthList(DEFAULT_PARAMETERS);
    }, []);

    const filesList: Partial<Record<DOCUMENTS_LIST, string>> = useMemo(() => {
        const codes = DEFAULT_PARAMETERS?.codes?.split(',') || [];

        return Object.fromEntries(codes?.map((code) => [code, getFileUrlByCode(filesData, code as DOCUMENTS_LIST)]));
    }, [filesData]);

    return (
        <Wrapper>
            <SizeContainer>
                <LinksContainer>
                    <LinksItem>
                        <LinksList>
                            <StyledLink href={filesList['user-agreement']} target='_blank'>
                                Пользовательское соглашение
                            </StyledLink>
                            <StyledLink href={filesList['interaction-agreement']} target='_blank'>
                                Оферта на заключение соглашения о взаимодействии
                            </StyledLink>
                        </LinksList>
                    </LinksItem>

                    <LinksItem>
                        <LinksList>
                            <StyledLink href={filesList['privacy-policy']} target='_blank'>
                                Политика конфиденциальности сервиса
                            </StyledLink>
                            <StyledLink href={filesList['data-processing-policy']} target='_blank'>
                                Политика обработки персональных данных компании
                            </StyledLink>
                        </LinksList>
                    </LinksItem>
                </LinksContainer>
            </SizeContainer>
        </Wrapper>
    );
};
